@if(loader){
<app-loader></app-loader>
}
<p-card [header]="isEditMode ? 'Update Store Consumption' : 'Create Store Consumption'">
  <form [formGroup]="storeConsumptionForm">
    <div class="col">
      <div class="field col-12 flex justify-content-between align-items-center">
        <div class="col">
          <div class="flex justify-content-start gap-3">
            @if(isEditMode){
            <p-button label="Update" class="p-button-outlined" icon="pi pi-save" size="small"
              (click)="saveOrUpdate()"></p-button>
            } @else {
            <p-button label="Save" class="p-button-outlined" icon="pi pi-save" size="small"
              (click)="saveOrUpdate()"></p-button>
            }
            <p-button label="Cancel" class="p-button-outlined" icon="pi pi-times" severity="danger" size="small"
              (click)="cancel()"></p-button>
          </div>
        </div>

        <div>
          <label class="block label-required" style="font-weight: bold;">Required Field</label>
        </div>
      </div>

    </div>
    <div class="grid">
      <div class="col">
        <div class="field text-left">
          <label class="label-required display">SC Number</label>
          <div class="flex align-items-center">
            <input pInputText type="text" formControlName="scCode" class="w-full" placeholder="e.g S307"
              [readonly]="isEditMode || !formControls.manualEntry.value" (blur)="checkSCNumber()"
              [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.scCode.errors}">
            <div *ngIf="!isEditMode" class="ml-2">
              <p-checkbox formControlName="manualEntry" (onChange)="manualEntry()" [binary]="true" label="Manual Entry"
                value="true"></p-checkbox>
            </div>
          </div>
        </div>

        <div class="field text-left">
          <label class="label-required display">From Date</label>
          <div class="p-inputgroup p-lookup">
            <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="fromDate" styleClass="w-full"
              [showIcon]="true"
              [ngClass]="{ 'ng-invalid ng-dirty': submitted && formControls.fromDate.invalid }"></p-calendar>
          </div>
        </div>

        <div class="field text-left">
          <label>Total Labor Cost</label>
          <input pInputText class="w-full" formControlName="totLaborCost" type="number" readonly
            [ngClass]="{ 'ng-invalid ng-dirty': submitted && formControls.totLaborCost.invalid }" />
        </div>
      </div>

      <div class="col">
        <div class="field text-left">
          <label class="label-required display">Employee/Contractor Name</label>
          <input pInputText class="w-full" formControlName="empName"
            [ngClass]="{ 'ng-invalid ng-dirty': submitted && formControls.empName.invalid }" />
        </div>

        <div class="field text-left">
          <label>End Date</label>
          <div class="p-inputgroup p-lookup">
            <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="endDate" styleClass="w-full"
              [showIcon]="true"></p-calendar>
          </div>
        </div>

        <div class="field text-left">
          <label>Project Name</label>
          <div style="display: flex; align-items: center;">
            <input pInputText class="w-full" formControlName="projectBoMName" />
            <div style="margin-left: 10px;">
              <p-button icon="pi pi-search" (click)="getProduct()" [raised]="true" [size]="'small'"
                severity="info"></p-button>
            </div>
          </div>
        </div>
      </div>

      <div class="col">
        <div class="field text-left">
          <label>Labor Rate</label>
          <input pInputText class="w-full" formControlName="laborRate" type="number"
            [ngClass]="{ 'ng-invalid ng-dirty': submitted && formControls.laborRate.invalid }" />
        </div>

        <div class="field text-left">
          <label class="label-required display">Total Days</label>
          <input pInputText class="w-full" formControlName="totDays" type="number" readonly
            [ngClass]="{ 'ng-invalid ng-dirty': submitted && formControls.totDays.invalid }" />
        </div>

        <div class="field text-left">
          <label class="label-required display">{{unitLabel}}</label>
          <p-autoComplete formControlName="warehouse" [dropdown]="true" (onSelect)="setWarehouse($event)"
            [forceSelection]="true" [suggestions]="filtewarehouse" (completeMethod)="filteWarehouse($event)"
            field="warehouseName" placeholder="Search {{unitLabel}}" styleClass="w-full"
            [ngClass]="{ 'ng-invalid ng-dirty': submitted && formControls.warehouse.invalid }">
            <ng-template let-item pTemplate="item">
              <span>{{item.warehouseCode}} - {{item.warehouseName}}</span>
            </ng-template>
          </p-autoComplete>
        </div>
      </div>
    </div>

    <div class="mt-3">
      <p-tabView>
        <p-tabPanel header="Components">
          <div>
            <div class="flex mb-1">
              <p-button label="Add" class="p-button-outlined mr-3" size="small" severity="secondary"
                (onClick)="addNewItem()"></p-button>
              <p-button icon="pi pi-pencil" size="small" severity="secondary" class="p-button-outlined mr-3"
                *ngIf="selectedProduct && selectedProduct.length === 1" (onClick)="editItem()"></p-button>
              <p-button class="p-button-outlined mr-3" icon="pi pi-trash" size="small" severity="danger"
                (onClick)="deleteSClineItems()" *ngIf="selectedProduct && selectedProduct.length > 0"></p-button>
            </div>
            <p-table #dt1 [value]="storeconsumptionData" [scrollable]="true" scrollHeight="300px"
              styleClass="p-datatable-striped" responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm"
              [paginator]="true" [rows]="10" [totalRecords]="storeconsumptionData.length" [selectionPageOnly]="true"
              [(selection)]="selectedProduct" [globalFilterFields]="['productCode']" [rowsPerPageOptions]="[10,15,20]">
              <ng-template pTemplate="header">
                <tr>
                  <th>
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                  </th>
                  <th>Sr.No</th>
                  <th>Product Name</th>
                  <th>Opening Inventory</th>
                  <th>Consumed Qty</th>
                  <th>Closing Inventory</th>
                  <th>Consumed In Operation</th>
                  <th>Rate</th>
                  <th>Total Cost</th>
                  <th>Date</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr>
                  <td>
                    <p-tableCheckbox [value]="item"></p-tableCheckbox>
                  </td>
                  <td>{{item.serialNumber}}</td>
                  <td class="text-blue-500 underline" style="cursor: pointer;" (click)="editItemFromRow(item)">
                    {{ item.productCode }}
                  </td>
                  <td>{{item.openingInventory}}</td>
                  <td>{{item.consumedQty}}</td>
                  <td>{{item.closingInventory}}</td>
                  <td>{{item.consumedInOperation}}</td>
                  <td>{{item.rate}}</td>
                  <td><span>₹ {{ item.totCost.toLocaleString('en-IN',{
                      minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span></td>
                  <td>{{item.date | date: 'dd/MM/yyyy'}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="footer">
                <tr>
                  <td colspan="3"></td>
                  <td class="font-bold text-right">Total Qty:</td>
                  <td class="font-bold">{{ totalConsumedQty }}</td>
                  <td colspan="3" class="font-bold text-right">Total Cost:</td>
                  <!-- <td class="font-bold">{{ totalCost }}</td> -->
                  <td><span>₹ {{ totalCost.toLocaleString('en-IN',{
                      minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span></td>
                  <td colspan="5"></td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>
  </form>
</p-card>

<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>

<p-dialog [header]="isEditModesc ? 'Update Store Consumption Line Item' : 'Add Store Consumption Line Item'"
  [modal]="true" [(visible)]="visible" [style]="{ width: '70vw', maxWidth: '1100px' }" [draggable]="false"
  headerClass="'no-close-icon'">
  <div>
    <form [formGroup]="storeConsumptionLineitemForm">
      <div class="field col-12 flex justify-content-between align-items-center">
        <div class="flex justify-content-start gap-3">
          @if(isEditModesc){
          <p-button label="Update" class="p-button-outlined" icon="pi pi-save" size="small"
            (click)="CreateStoreConsumptionLineitem(storeConsumptionLineitemForm.value)"></p-button>
          } @else {
          <p-button label="Save" class="p-button-outlined" icon="pi pi-save" size="small"
            (click)="CreateStoreConsumptionLineitem(storeConsumptionLineitemForm.value)"></p-button>
          }
          <p-button label="Cancel" class="p-button-outlined ml-2" icon="pi pi-times" severity="danger" size="small"
            (click)="cancels()"></p-button>
        </div>

        <div>
          <label class="block label-required" style="font-weight: bold;">Required Field</label>
        </div>
      </div>
      <div class="grid padd">
        <div class="col">
          <div class="field text-left mb-3">
            <label class="label-required display">Serial Number</label>
            <div class="flex align-items-center">
              <input pInputText type="text" formControlName="serialNumber" class="w-full"
                [readonly]="isEditModesc || !storeConsumptionLineitemForm.controls['manualEntry2'].value"
                (blur)="checkMONumber()" />
              <div *ngIf="!isEditModesc" class="ml-2">
                <p-checkbox formControlName="manualEntry2" (onChange)="manualEntry2()" [binary]="true"
                  label="Manual Entry" value="true"></p-checkbox>
              </div>
            </div>
          </div>
          <div class="field text-left">
            <label>Consumed In Operation</label>
            <textarea rows="1" pInputTextarea formControlName="consumedInOperation" class="w-full"
              [ngClass]="{ 'ng-invalid ng-dirty': submitted && formControlslineitem.consumedInOperation.invalid }"></textarea>
          </div>
          <div class="field text-left">
            <label class="label-required display">Rate</label>
            <input pInputText class="w-full" type="number" formControlName="rate" (input)="calculateTotalCost()"
              [ngClass]="{ 'ng-invalid ng-dirty': submitted && formControlslineitem.rate.invalid }" />
          </div>
        </div>
        <div class="col">
          <div class="field text-left">
            <label class="label-required display">Products</label>
            <p-autoComplete #productCodeAutoComplete formControlName="productCode" placeholder="Search products"
              (onSelect)="setProducts($event)" [suggestions]="nonInventryProductList"
              (completeMethod)="autoSearchNonInventryProducts($event)" field="customerCode" class="w-full"
              [ngClass]="{ 'ng-invalid ng-dirty': submitted && formControlslineitem.productCode.invalid }">
              <ng-template let-item pTemplate="item" class="w-full">
                <span>{{item.productCode}} - {{item.productName}}</span>
              </ng-template>
            </p-autoComplete>
          </div>
          <div class="field text-left">
            <label class="label-required display">Consumed Quantity</label>
            <input pInputText class="w-full" formControlName="consumedQty" type="number"
              (input)="calculateTotalCost()" />
          </div>
          <div class="field text-left">
            <label class="label-required display">Opening Inventory</label>
            <input pInputText placeholder="0" type="number" min="0" formControlName="openingInventory" class="w-full" />
          </div>
          <!-- <div class="field text-left">
            <label>Item Description</label>
            <textarea rows="1" pInputTextarea formControlName="description" class="w-full"></textarea>
          </div> -->
        </div>
        <div class="col">
          <!-- <div class="field text-left">
            <label>Quantity Avail</label>
            <input pInputText placeholder="0" type="number" readonly min="0" formControlName="quantityAvail" class="w-full" />
          </div> -->
          <div class="field text-left">
            <label>Total Cost</label>
            <input pInputText class="w-full" formControlName="totCost" type="number" readonly />
          </div>
          <div class="field text-left">
            <label class="label-required display">Date</label>
            <div class="p-inputgroup p-lookup">
              <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="date" styleClass="w-full"
                [showIcon]="true" appendTo="body"></p-calendar>
            </div>
          </div>
          <div class="field text-left">
            <label>Closing Inventory</label>
            <input pInputText placeholder="0" type="number" min="0" formControlName="closingInventory" class="w-full" />
          </div>
        </div>
      </div>
    </form>
  </div>
</p-dialog>